import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'includesString',
})
export class IncludesStringPipe implements PipeTransform {
	transform(value: string | string[], searchString?: string | string[]): any {
		return includesString(value, searchString);
	}
}

export function includesString(value: string | string[], searchString?: string | string[]): any {
	if (!value || !searchString) {
		return false;
	}
	if (Array.isArray(value)) {
		return value.some((v) => searchString.includes(v));
	} else if (Array.isArray(searchString)) {
		return searchString.some((s) => value.includes(s));
	}
	return value.includes(searchString);
}
